import { Image } from './common';
import { createErrorMessageTypeGuard } from './createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from './makeRequest';
import { User } from './users';

export type Team = {
   teamid: number;
   name: string;
   avatarUrl: string;
   imageUrl?: string;
   description: string;
   image: Image;
   member_count: number;
   owner: number;
   reputation: number;
};

export async function getTeam(teamid: number, common: CommonRequestOptions = {}): Promise<Team> {
   return makeRequest('get', `teams/${teamid}/attributes`, common);
}

type GetTeamErrorCode = 'teams.team_not_found';
getTeam.errorMessages = createErrorMessageTypeGuard<GetTeamErrorCode>();

export type GetTeamsSortOption = 'ASC' | 'DESC';

export type GetTeamsOrderByOption = 'teamid' | 'name' | 'reputation';

export type GetTeamsOptions = CommonRequestOptions & {
   limit?: number;
   offset?: number;
   order?: GetTeamsSortOption;
   joinedSince?: number;
   ownerTeamUserid?: number;
   orderBy?: GetTeamsOrderByOption;
};

export function getTeams({
   limit,
   offset,
   order,
   joinedSince,
   ownerTeamUserid,
   orderBy,
   ...common
}: GetTeamsOptions = {}): Promise<Team[]> {
   return makeRequest('get', 'teams', {
      ...common,
      query: {
         limit,
         offset,
         order,
         joinedSince,
         ownerTeamUserid,
         orderBy,
      },
   });
}

export type SearchTeamsOptions = CommonRequestOptions & {
   limit?: number;
   page?: number;
   uniqueOnly?: boolean;
   ownerTeamUserid?: number;
};

export type SearchTeamsResult = {
   results: Team[];
   totalResults: number;
   moreResults: boolean;
   limit: number;
   search: string;
};

export async function searchTeams(
   searchTerm: string,
   { limit, ownerTeamUserid, page, uniqueOnly, ...common }: SearchTeamsOptions = {}
): Promise<SearchTeamsResult> {
   return makeRequest('get', `teams/search/${encodeURIComponent(searchTerm)}`, {
      ...common,
      query: {
         limit,
         page,
         uniqueOnly,
         ownerTeamUserid,
      },
   });
}

export type GetTeamMembersOptions = CommonRequestOptions & {
   order?: GetTeamsSortOption;
};

export function getTeamMembers(
   teamid: number,
   { order, ...common }: GetTeamMembersOptions = {}
): Promise<User[]> {
   return makeRequest('get', `teams/${teamid}`, {
      ...common,
      query: {
         order,
      },
   });
}
